import { render, staticRenderFns } from "./SearchServicioComponent.vue?vue&type=template&id=267404b6&scoped=true&"
import script from "./SearchServicioComponent.vue?vue&type=script&lang=js&"
export * from "./SearchServicioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267404b6",
  null
  
)

export default component.exports